import { reactive } from 'vue';

import ApiService from '../services/api.service';

import router from '@/router';

export default function useAuth() {
  const formLogin = reactive({
    email: '',
    password: '',
    remember: false
  });

  const submitLogin = async (loginForm) => {
    return await ApiService.post('/auth/login', loginForm)
      .then(async (response) => {
        return response.data;
      })
      .catch((error) => {
        // Handle errors here
        return {
          status: false
        };
        console.log('error' + error);
      });
  };

  const LogoutUser = async () => {
    await ApiService.post('/auth/logout').then((response) => {
      if (response.status == 200) {
        localStorage.clear();
        router.push('/');
      }
    });
  };

  return {
    formLogin,
    submitLogin,
    LogoutUser
  };
}
